import React, { useRef } from "react";
import Checkbox from "./Checkbox";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

interface Props extends RowItem, Omit<InterfaceComponentsProps,"icon"> { 
    required: boolean;
    placeholder: string;
    onChange: (arg:string) => any;
    onBlur?: () => any;
    checkboxModel: boolean;
    checkboxChanged: (...args:any) => any
    tableClass:string
    model: any
}

function DatePicker(props:Partial<Props>) {
    const datePickerRef = useRef<HTMLInputElement>(null);
    //https://reactdatepicker.com/#example-custom-date-format
    // اذا بدنا نثبت الفورمات
    function getDateString(date:string) {
        try {
            let returnDate = new Date(date)
            let year :string | number= returnDate.getFullYear();
            year = year < 10 ? "000" + year :
                year < 100 ? "00" + year :
                    year < 1000 ? "0" + year : year;
            if (isNaN(returnDate.getMonth()) || isNaN(returnDate.getDate()))
                throw new Error("not valid number");
            return (
                year + "-" +
                (returnDate.getMonth() < 9 ? "0" : "") +
                (returnDate.getMonth() + 1) +
                "-" +
                (returnDate.getDate() < 10 ? "0" : "") +
                returnDate.getDate()
            );
        } catch (e) {
            return date;
        }
    }

    function handler(event:any) {
        const { value } = event.target;
            props?.onChange?.(value);
    }

    function blurhandler(event:any) {
        const { value } = event.target;
        if (value === '')
            props?.onChange?.(app.today());
        else
            props?.onBlur?.();
            

    }
    var datePicker = <input
        id={props.id ? props.id : "date" + props.label}
        ref={datePickerRef}
        type="date"
        value={getDateString(props.model)}
        className={`form-control form-control-sm rounded ${props.required && !props.model ? " is-invalid  border-1" :
            props.isTable ? " border-1 text-center bg-body-tertiary " + props.tableClass : ("border-0 " + props.class)}`}
        disabled={props.disabled || props.checkboxModel === false}
        onChange={handler}
        onBlur={blurhandler}
        placeholder={app.translate(props.placeholder)}
        max="3000-12-31"
        required={props.required}
    />;
    var pikerButton = <button className="btn btn-sm border-0 pt-1 px-2 btn-primary" type="button" onClick={openPicker} disabled={props.disabled || props.checkboxModel === false}>
        <i className={` iconssc-calender`} />
    </button>

    function openPicker() {
        datePickerRef.current?.showPicker()
    }

    return (
        props.isTable ?
            <div className="input-group">
                {datePicker}
                {pikerButton }
            </div>
                :
        <div className="mt-1">
                <label className={(props.labelClass ||"fw-semibold text-primary-emphasis")}>{app.translate(props.label)}</label>
            <div className="input-group border rounded">
                    {props.checkboxChanged && <Checkbox id="IsFrom" class="mt-1 ms-2" className="text-center"
                        model={props.checkboxModel!} onChange={props.checkboxChanged} />}
                    {datePicker}
                    {pikerButton }
            </div>
        </div>
    );
}

DatePicker.defaultProps = {
    label: "Date",
    model: new Date(),
    placeholder: "",
    class: " ",
    disabled: false,
    required: false,
    isTable: false
}

export default DatePicker;